<ion-content class="dashboard-customize">
  <ng-container *ngIf="!isExtended">
    <div class="heading">
      <ion-label class="title">{{'Add'|translate}} {{type|translate}}</ion-label>
      <img tooltip="{{'Close' | translate }}" alt="" placement="bottom" src="/assets/icon/cancel.svg" class="cross-icon" (click)="close()">
    </div>

      <form class="form-scroll scrollVertical" #formEle #addCustomSection="ngForm" autocomplete="off" novalidate>
        <div class="inp-container" [hidden]="section.isDelete" *ngFor="let section of newSectionList;let i = index" [ngModelGroup]="''+i">
          <ion-label style="font-weight: bold;"> {{ 'Section' | translate }} *</ion-label>
          <ion-item lines=none>
            <ion-input  placeholder="{{'Enter Section Name' | translate }}" name="section" required [(ngModel)]="section.section"
            #sectionInp="ngModel">
            </ion-input>
            <ion-checkbox [(ngModel)]="section.isEdited" name="isEdited" #isEditedInp="ngModel"  [hidden]="true" style="margin-right: 20px;" class="col-checkbox" id="roadmap_checkbox_{{section.isEdited}}"></ion-checkbox>
            <ion-checkbox [(ngModel)]="section.isDelete" name="isDelete" #isDeleteInp="ngModel" [hidden]="true" id="roadmap_checkbox_{{section.isDelete}}"></ion-checkbox>
            <ion-checkbox [(ngModel)]="section.isEdit" name="isEdit" #isEditInp="ngModel" [hidden]="true" id="roadmap_checkbox_{{section.isEdit}}"></ion-checkbox>
            <ion-checkbox [(ngModel)]="section.uiIsEdit" name="uiIsEdit" #uiIsEdit="ngModel" [hidden]="true" id="roadmap_checkbox_{{section.uiIsEdit}}"></ion-checkbox>
            <ion-icon *ngIf="newSectionList.length>1" (click)="deleteSections(section,i)" name="trash-outline"><!--(click)="newSectionList.splice(i,1)"-->
            </ion-icon>
          </ion-item>
         
          <ion-text style="font-size: x-small; font-weight: bold;" *ngIf="sectionInp.invalid && sectionInp.touched"
            color="danger">
            {{ 'required' | translate }}
          </ion-text>
        </div>
      </form>
      <ion-row class="row-margin-top">
        <ion-col class="add-button-col">
          <ion-button class="app-large-btn" shape="round" fill="outline" color="primary" (click)="addNew(formEle)">
            <ion-icon slot=start  name='add-circle-outline'></ion-icon>
            {{'Add'|translate}} {{type|translate}}
          </ion-button>
        </ion-col>
        <ion-col class="save-button-col">
          <ion-button class="app-btn" shape="round" fill="outline" color="primary" (click)="submit(addCustomSection)">
            {{'Save'|translate}}
          </ion-button>
        </ion-col>
      </ion-row>
   
    </ng-container>
  <div *ngIf="isExtended">
    <span>
      <div class="close-icon" (click)="close()">
        <img src="/assets/icon/cancel.svg" alt="">
      </div>
      <div class="title">
        <span>{{type}}</span><br>
        <small>{{ 'roadmap_extension_rename_note' | translate }}</small>
      </div>
    </span>
    <div class="sec-container">
      <form #addCustomSection="ngForm" autocomplete="off" novalidate class="add-section-form">
        <div class="inp-container">
          <ion-label style="font-weight: bold;">{{ 'Roadmap Name' | translate }}</ion-label>
          <div class="sec-inp-container">
            <ion-item lines=none>
              <ion-input placeholder="{{ 'Enter Roadmap Name' | translate }}"name="roadmap" required ngModel
                #sectionInp="ngModel">
              </ion-input>
            </ion-item>
          </div>
          <ion-text style="font-size: x-small; font-weight: bold;" *ngIf="sectionInp.invalid && sectionInp.touched"
            color="danger">
            {{ 'required' | translate }}
          </ion-text>
        </div>
      </form>
      <div class="save-button">
        <ion-button class="app-btn" shape="round" fill="outline" color="primary" (click)="submit(addCustomSection)">
          {{'Save'|translate}}
        </ion-button>
      </div>
    </div>
  </div>
</ion-content>